import { whiteList } from './conf'
// 检查是否为上报白名单中类型
export function needReport (conf) {
  try {
    const item = whiteList.find(ele => ele.tag === conf)
    return item
  } catch (error) {
    console.error('【queryTable-needReport】：【上报白名单未找到对应的配置】', error)
    throw error
  }
}
// 获取挂载在window下的公共参数
export function getErpCommonParams (key) {
  return window[key] || {}
}



// WEBPACK FOOTER //
// ./src/public/mixins/component-report/tools.js